module.exports = __webpack_public_path__ + "static/img/A156.76aa9e57.jpg";